/** Returns false when user.track is false (impersonation) or on test pages */
export function isSessionAnalyticsAllowed(): boolean {
  if (window.testing != null) {
    return false;
  }
  const user = window.user ?? window.bootstrapUser;
  return user == null || user.track;
}
